import { Box, Flex, Grid, Heading, Text } from "@radix-ui/themes";
import { HeroStyle2 } from "~/components/HeroStyle2";
import { HomeConsultForm } from "~/components/home/HomeConsultForm";
import { LinkCta } from "~/components/LinkCta";
import {
	Locale,
	useLocalization,
} from "~/components/localization/LocalizationProvider";
import styles from "../live-seo-page.module.css";

type CovidLocalization = {
	title: string;
	patientHeading: string;
	contactMessage: string;
	currentPatientsHeading: string;
	currentPatientsText: string;
	currentPatientsCta: string;
	newPatientsHeading: string;
	newPatientsText: string;
	newPatientsCta: string;
};

const covidLocalization = {
	[Locale.EN]: {
		title: "COVID-19 Office Update",
		patientHeading: "Patient Instructions",
		contactMessage:
			"Please contact our office for current patient instructions and appointment information.",
		currentPatientsHeading: "Current Patients",
		currentPatientsText:
			"Contact our team with questions about your treatment or appointments.",
		currentPatientsCta: "Contact Our Office",
		newPatientsHeading: "New Patients",
		newPatientsText: "Schedule your first consultation with our team.",
		newPatientsCta: "Schedule a Consultation",
	},
	[Locale.ES]: {
		title: "Actualización de la oficina sobre COVID-19",
		patientHeading: "Instrucciones para pacientes",
		contactMessage:
			"Comunícate con nuestra oficina para obtener las instrucciones actuales para pacientes e información sobre citas.",
		currentPatientsHeading: "Pacientes actuales",
		currentPatientsText:
			"Comunícate con nuestro equipo si tienes preguntas sobre tu tratamiento o tus citas.",
		currentPatientsCta: "Contacta con nuestra oficina",
		newPatientsHeading: "Nuevos pacientes",
		newPatientsText:
			"Programa tu primera consulta con nuestro equipo.",
		newPatientsCta: "Programa una consulta",
	},
} satisfies Record<Locale, CovidLocalization>;

export function CovidPage() {
	const getLocalization = useLocalization(covidLocalization);

	const instructionCards = [
		{
			heading: getLocalization("currentPatientsHeading"),
			text: getLocalization("currentPatientsText"),
			cta: getLocalization("currentPatientsCta"),
			href: "/contact-us",
		},
		{
			heading: getLocalization("newPatientsHeading"),
			text: getLocalization("newPatientsText"),
			cta: getLocalization("newPatientsCta"),
			href: "/free-consult",
		},
	];

	return (
		<Flex direction="column">
			<HeroStyle2
				heroImageUrl="/miami-ortho-3.jpg"
				title={getLocalization("title")}
				backgroundPosition="center"
			/>
			<Box className={styles.covidBand}>
				<Box className={styles.covidInner}>
					<Heading as="h2" className={styles.covidHeading}>
						{getLocalization("patientHeading")}
					</Heading>
					<Text as="p" className={styles.covidText}>
						{getLocalization("contactMessage")}
					</Text>
					<Grid
						columns={{ initial: "1", sm: "2" }}
						gap="5"
						className={styles.covidInstructionGrid}
					>
						{instructionCards.map((card) => (
							<Box className={styles.covidInstructionCard} key={card.href}>
								<Heading as="h3" className={styles.covidCardHeading}>
									{card.heading}
								</Heading>
								<Text as="p" className={styles.covidText}>
									{card.text}
								</Text>
								<Box className={styles.covidCtaWrap}>
									<LinkCta to={card.href} px="5" py="3">
										{card.cta}
									</LinkCta>
								</Box>
							</Box>
						))}
					</Grid>
				</Box>
			</Box>
			<Box className={styles.formWrap}>
				<HomeConsultForm />
			</Box>
		</Flex>
	);
}
